<nav class="navbar navbar-expand-lg nav-Color">
    <div class="container-fluid">
        <a class="navbar-brand" href="#">
            <img class="logo" src="./assets/img/lengua.png" alt="Bravum">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown" aria-expanded="false" [attr.aria-label]="'navigation.toggle' | t">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <ul class="navbar-nav">
                <li class="nav-item" *ngFor="let item of menu" [ngClass]="{'dropdown': item.type === 2}">
                    <a *ngIf="item.type == 1" class="nav-link" href="#">{{ item.name | t }}</a>

                    <a *ngIf="item.type == 2" class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        {{ item.name | t }}
                    </a>
                    <ul *ngIf="item.type == 2" class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                        <li *ngFor="let drop of item.options">
                            <a class="dropdown-item" href="#">{{ drop.name }}</a>
                        </li>
                    </ul>
                </li>
                
            </ul>
        </div>
    </div>
</nav>
